"use client";

import { BuilderMarketingLandingPage } from "@faire/retailer-visitor-shared/views/builder/BuilderMarketingLandingPage";
import { IRouteMetadata, Route } from "@faire/web-api--source/Route";
import { props as affiliatesRouteProps } from "@faire/web-api--source/routes/www/affiliates";
import { props as atlRouteProps } from "@faire/web-api--source/routes/www/atl";
import { props as atlantamarketRouteProps } from "@faire/web-api--source/routes/www/atlanta-market";
import { props as autumnFairRouteProps } from "@faire/web-api--source/routes/www/autumn-fair";
import { props as builderRouteProps } from "@faire/web-api--source/routes/www/builder";
import { props as builderTestingRouteProps } from "@faire/web-api--source/routes/www/builder-testing";
import { props as directMail1RouteProps } from "@faire/web-api--source/routes/www/direct-mail1";
import { props as expoRouteProps } from "@faire/web-api--source/routes/www/expo";
import { props as faireForecast2025RouteProps } from "@faire/web-api--source/routes/www/faire-forecast-2025";
import { props as fancyFoodRouteProps } from "@faire/web-api--source/routes/www/fancy-food";
import { props as forecastRouteProps } from "@faire/web-api--source/routes/www/forecast";
import { props as grandPrixRouteProps } from "@faire/web-api--source/routes/www/grand-prix";
import { props as harrogateRouteProps } from "@faire/web-api--source/routes/www/harrogate";
import { props as magiclvRouteProps } from "@faire/web-api--source/routes/www/magiclv";
import { props as newyear25RouteProps } from "@faire/web-api--source/routes/www/NEWYEAR25";
import { props as pglRouteProps } from "@faire/web-api--source/routes/www/pgl";
import { props as springFairRouteProps } from "@faire/web-api--source/routes/www/spring-fair";
import { props as standAgainstBlandRouteProps } from "@faire/web-api--source/routes/www/stand-against-bland";
import { props as trendsetRouteProps } from "@faire/web-api--source/routes/www/trendset";
import React from "react";

export const RenderMarketingBuilderPageRoute = () => {
  const builderLPRoutes: Array<IRouteMetadata & { path: string }> = [
    builderRouteProps,
    pglRouteProps,
    affiliatesRouteProps,
    fancyFoodRouteProps,
    atlantamarketRouteProps,
    magiclvRouteProps,
    standAgainstBlandRouteProps,
    harrogateRouteProps,
    autumnFairRouteProps,
    grandPrixRouteProps,
    directMail1RouteProps,
    builderTestingRouteProps,
    atlRouteProps,
    expoRouteProps,
    springFairRouteProps,
    trendsetRouteProps,
    faireForecast2025RouteProps,
    newyear25RouteProps,
    forecastRouteProps,
  ];
  return builderLPRoutes.map((route) => {
    return (
      <Route
        {...route}
        component={BuilderMarketingLandingPage}
        exact
        key={route.path}
      />
    );
  });
};
